import AuthRepository from './auth.repository';
import PackageRepository from './package.repository';
import PaymentRepository from './payment.repository';
import UserSettingsRepository from './user-settings.repository';
import BreakoutToolRepository from './breakout-tool.repository';
import NoteAIRepository from './note-ai.repository';

class RepositoryFactory {
  getRepository(serviceName) {
    switch (serviceName) {
    case 'auth':
      return AuthRepository;
    case 'packages':
      return PackageRepository;
    case 'payment':
      return PaymentRepository;
    case 'user-settings':
      return UserSettingsRepository;
    case 'breakout-tool':
      return BreakoutToolRepository;
    case 'note-ai':
      return NoteAIRepository;
    default:
      throw Error('Invalid param');
    }
  }
}

export default new RepositoryFactory();
